"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timeline = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var styled_1 = require("../../styled");
var defaultStyles = {
    svg: {},
    stepsWrapper: {},
    stepTextWrapper: {}
};
var Timeline = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep, _b = _a.stepBaseIndex, stepBaseIndex = _b === void 0 ? 1 : _b, _c = _a.wrapperWidth, wrapperWidth = _c === void 0 ? '64rem' : _c, _d = _a.styles, styles = _d === void 0 ? defaultStyles : _d, _e = _a.isError, isError = _e === void 0 ? false : _e;
    var lineWidth = 2;
    var center = lineWidth / 2;
    var right = 100 - lineWidth / 2;
    var viewBoxString = "0 0 100 " + lineWidth * 2;
    var stepsCount = steps.length;
    var offset = (100 / (stepsCount - 1)).toFixed(3);
    var pathString = "M " + lineWidth + ", " + lineWidth + " L " + right + ", " + lineWidth;
    // ensure that the activeStep value is always pointing 1 status ahead in steps
    // stepBaseIndex = 1: activeStep not changed
    // stepBaseIndex < 1: activeStep incremented based on base index (e.g. if 0, add 1)
    // stepBaseIndex > 1: activeStep decremented based on base index (e.g. if 2, minus 1)
    var adjustedActiveStep = stepBaseIndex === 1
        ? activeStep
        : stepBaseIndex < 1
            ? activeStep + (Math.abs(stepBaseIndex) + 1)
            : activeStep - (stepBaseIndex - 1);
    var getHorizontalPosition = function (offset, index, totalSegements, padding) {
        var pos = offset * index;
        if (index === totalSegements - 1) {
            return pos - padding;
        }
        else if (index === 0) {
            return pos + padding;
        }
        return pos;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("svg", { viewBox: viewBoxString, preserveAspectRatio: "none", style: styles.svg }, steps.map(function (step, index) {
            var circlePosition = getHorizontalPosition(offset, index, stepsCount, lineWidth);
            var lineStart = getHorizontalPosition(offset, index, stepsCount, lineWidth);
            lineStart -= lineWidth;
            var lineEnd = getHorizontalPosition(offset, index - 1, stepsCount, lineWidth);
            lineEnd += lineWidth;
            var stepColor = getStepColor(adjustedActiveStep, index, isError);
            var linePathString = "M " + lineStart + ", " + lineWidth + " L " + lineEnd + ", " + lineWidth;
            return (React.createElement("g", { key: "timline-segment-" + index },
                index > 0 && (React.createElement("path", { d: linePathString, strokeDasharray: index === adjustedActiveStep ? '0.5, 0.5' : '', strokeLinecap: "round", stroke: stepColor, strokeWidth: 0.25, fillOpacity: "0" })),
                React.createElement("circle", { cx: circlePosition, cy: lineWidth, r: "0.75", stroke: stepColor, strokeWidth: 2, fill: stepColor, strokeOpacity: 0.25 })));
        })),
        React.createElement(StepWrapper, { style: __assign({ width: wrapperWidth }, styles.stepsWrapper) }, steps.map(function (step, index) { return (React.createElement(StepTextWrapper, { key: "timeline-step-text-" + index, style: __assign(__assign({}, styles.stepTextWrapper), (step.style ? step.style : {})) },
            React.createElement(StepTitle, { color: getStepColor(adjustedActiveStep, index, isError) }, step.title),
            React.createElement(StepSubtitle, null, step.subtitle))); }))));
};
exports.Timeline = Timeline;
var StepWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var StepTextWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var StepTitle = styled_1.default.h6(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0.66rem 0;\n  color: ", ";\n"], ["\n  margin: 0.66rem 0;\n  color: ", ";\n"])), function (props) { return props.color || props.theme.colors.black50; });
var StepSubtitle = styled_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 300;\n"], ["\n  color: ", ";\n  font-weight: 300;\n"])), function (props) { return props.theme.colors.black50; });
var getStepColor = function (adjustedActiveStep, stepIndex, isError) {
    if (isError) {
        return theme_1.colors.error;
    }
    return adjustedActiveStep === stepIndex
        ? theme_1.colors.primary
        : adjustedActiveStep > stepIndex
            ? theme_1.colors.success
            : theme_1.colors.black50;
};
exports.default = exports.Timeline;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map